// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/virtual';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/grid';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid, Autoplay } from 'swiper';

import * as React from 'react';
import TextImageSection from '../text-image-section';

export default function FullWidthSliderContent({ blok }) {
  return (
    <div>
      <Swiper
        modules={[Grid, Autoplay]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: true,
        }}
        slidesPerView={1}
        grid={{ fill: 'row', rows: 1 }}
        className="w-full"
        spaceBetween={10}
        loop
      >
        {blok.slides.map((textSection) => (
          <SwiperSlide key={`swiper-slide-${textSection._uid}`}>
            <TextImageSection
              image={textSection.image}
              title={textSection.title}
              text={textSection.content}
              link={{
                url: textSection.button_link,
                label: textSection.button_text,
              }}
              subtitle={textSection.subtitle}
              altText={textSection.imageAlt}
              useSrcImage
              textAlign="text-center lg:text-left"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
